/**
 * The different paragraph 'styles' that denote paragraphs that can
 * contain actual Scripture (as opposed to headings, etc.)
 */
export const contentParaTypes = [
  'p',
  'm',
  'nb',
  'po',
  'pr',
  'cls',
  'pmo',
  'pm',
  'pmc',
  'pmr',
  'pi',
  'pi1',
  'pi2',
  'pi3',
  'mi',
  'pc',
  'ph',
  'ph1',
  'ph2',
  'ph3',
  'q',
  'q1',
  'q2',
  'q3',
  'qr',
  'qc',
  'qm',
  'qm1',
  'qm2',
  'qm3',
  'lh',
  'li',
  'li1',
  'li2',
  'li3',
  'li4',
  'lf',
  'litl',
];
